function SvgFlash(props) {
  return (
    <svg {...props} viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.55003 16.2L11.725 10H7.72503L8.45003 4.32502L3.82503 11H7.30003L6.55003 16.2ZM4.57703 19.4423L5.57703 12.5H0.952026L9.19228 0.605774H10.423L9.43278 8.50002H14.9325L5.80778 19.4423H4.57703Z" />
    </svg>
  );
}

export default SvgFlash;
